module.exports = __webpack_public_path__ + "fonts/Quicksand-SemiBold.d4f6bc5.ttf";